import ISlideFrame from '@/components/interfaces/SlideFrame';
import { plato_api_slide_frames_path } from '@/modules/routes';
import QueryKeys from '@/utils/QueryKeys';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

interface ApiResponse {
  data: ISlideFrame[];
}

export default function useSlideFrames() {
  return useQuery({
    placeholderData: ([] as ISlideFrame[]),
    queryFn: () => (
      axios
        .get<ApiResponse>(plato_api_slide_frames_path())
        .then(res => res.data.data)
    ),
    queryKey: [QueryKeys.SlideFrames],
  });
}
